import React, { useCallback, useRef, useState } from 'react';
import config from './config.json';
import { message, Badge } from 'antd';
import { modalAddOrEditFn } from './components/addOrEdit';
import { SActionBtn, SBack, SLowcodeList, STableActions } from 'shj-components'
import ExpandTable from './expandTable';
import KeepAlive from 'react-activation';
import { ruleConfigSearchList, receiptRuleState } from '@/services/integrationConfig'
export default function () {
  const listRef = useRef<any>();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const data = await ruleConfigSearchList(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      resolve({
        statusList: [
          {
            key: true,
            title: '启用',
          },
          {
            key: false,
            title: '禁用',
          },
        ],
      });
    });
  };

  const onEdit = (type: string, record: any) => {
    console.log(record);
    add({ ...record, type });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const add = (obj = {}) => {
    const {
      current: { reload },
    } = listRef;
    modalAddOrEditFn({
      fn: () => {
        reload();
      },
      ...obj,
    });
  };

  const edit = (obj: object) => {
    add(obj);
  };
  const onSave = useCallback((values, dialogDestroy) => { }, []);
  const onAdd = useCallback(() => {
    add({ type: 'add' });
  }, [onSave]);
  const onDisable = useCallback(({ record, rows, selectedRows } = {}) => {
    const list = [];
    for (let m of selectedRows) {
      list.push(m.id);
    }
    receiptRuleState({ ids: list, state: 2 }).then((response: any) => {
      message.success(response?.message);
      reloadFn();
    });
  }, []);

  const onEnable = useCallback(({ record, rows, selectedRows } = {}) => {
    const list = [];
    for (let m of selectedRows) {
      list.push(m.id);
    }
    receiptRuleState({ ids: list, state: 1 }).then((response: any) => {
      message.success(response?.message);
      reloadFn();
    });
  }, []);

  const onEnableChange = (checked: any, record: any) => {
    if (checked) {
      onEnable({ record });
    } else {
      onDisable({ record });
    }
  };
  //子表格
  const expandedRowRender = (record: any, a: any, b: any, c: boolean) => {
    // 直接冗余字段 嵌套子表格会闪烁？？？
    // const subList = (record.ruleConfigDtlList || []).map((item: any) => {
    //   return { ...item, ruleEnableTime: record?.enableTime, ruleStopTime: record?.stopTime };
    // });
    // return <ExpandTable clueId={record.id} listRef={listRef} list={subList || []} />;
    return (
      <ExpandTable clueId={record.id} listRef={listRef} list={record.ruleConfigDtlList || []} currentRow={record} />
    );
  };
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onEnable, onDisable, onEnableChange },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      statusCell(text: any) {
        return (
          <div>
            {text ? (
              <>
                <Badge status="success" />
                启用
              </>
            ) : (
              <>
                <Badge status="error" />
                禁用
              </>
            )}
          </div>
        );
      },
      // 渲染操作栏
      renderOperate(text: string, record: any) {
        return (
          <div className="actionBox">
            <STableActions>
              <SActionBtn onClick={() => onEdit('edit', record)}>
                编辑
              </SActionBtn>
              <SActionBtn onClick={() => onEdit('view', record)}>
                查看
              </SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  };
  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <SBack title={`规则配置`}></SBack>
      <SLowcodeList
        config={{ ...config, tableType: 'antd' }}
        expandable={{ expandedRowRender }}
        ref={listRef}
        searchMode="group"
        {...extension}
      />
    </KeepAlive>
  );
}
